import { ChangeHandler, ControllerRenderProps } from "react-hook-form"

type FilterValueCb = (value: any) => boolean
type TransformValueCb = (value: any) => any
type OnChangeCb = (fieldOnChange: (...event: any[]) => void, value: any) => any

type CreateControlFnConfig = {
  filterValueCb?: FilterValueCb
  transformValueCb?: TransformValueCb
  onChangeCb?: OnChangeCb
}

/**
 *
 * @param filterValueCb Funzione che controlla se i caratteri inseriti sono validi tipicamente tramite regex
 * @param transformValueCb Funzione che applica eventuali trasformazioni al value
 * @returns {ControllerRenderProps}
 */
const createControlFn =
  ({
    filterValueCb = () => true,
    transformValueCb = (value) => value,
    onChangeCb = (fielOnChange, value) => fielOnChange(value),
  }: CreateControlFnConfig) =>
  (field: ControllerRenderProps<any, any>) => {
    const { onChange: fieldOnChange, ...restOfField } = field

    const onChange = (value: any) => {
      onChangeCb(fieldOnChange, value)
    }

    const filterInvalidChars: ChangeHandler = async (e) => {
      const value = transformValueCb(
        typeof e === "string" || typeof e === "number" ? e : e.target.value,
      )
      if (filterValueCb(value) || value === "") onChange(value)
    }
    return { ...restOfField, onChange: filterInvalidChars }
  }

export { createControlFn }
